export const supplierSidebarItems = [
  {
    id: "dashboard_supplier",
    text: "dashboard_supplier",
    link: "/dashboard",
    iconPath: "/icons/sidebar-icons/dashboard.svg",
    disabled: false,
  },
  {
    id: "find_communities",
    text: "find_communities",
    link: "/find-communities",
    iconPath: "/icons/sidebar-icons/users-search.svg",
    disabled: false,
  },
  {
    id: "communities_management",
    text: "communities_management",
    link: "/my-communities",
    iconPath: "/icons/sidebar-icons/manage-community.svg",
    showTooltip: true,
    disabled: false,
  },
  {
    id: "price_lists",
    text: "price_lists",
    link: "/manage-pricelists",
    iconPath: "/icons/sidebar-icons/pricelist-icon.svg",
    disabled: false,
  },
  {
    id: "my_jobs",
    text: "my_jobs",
    link: "/my-jobs",
    iconPath: "/icons/sidebar-icons/orders-job.svg",
    disabled: false,
  },
  {
    id: "business_settings",
    text: "business_settings",
    link: "/business-settings",
    iconPath: "/icons/sidebar-icons/business-settings.svg",
    showTooltip: true,
    disabled: false,
  },
];

export const communitySidebarItems = [
  {
    id: "dashboard_community",
    text: "dashboard_community",
    link: "/dashboard",
    iconPath: "/icons/sidebar-icons/dashboard.svg",
    disabled: false,
  },
  {
    // FE-first mock (Grow your community) — preview badge until the backend lands.
    id: "grow_community",
    text: "grow_community",
    link: "/grow-community",
    iconPath: "/icons/sidebar-icons/users-plus.svg",
    disabled: false,
    preview: true,
  },
  {
    id: "find_suppliers",
    text: "find_suppliers",
    link: "/find-suppliers",
    iconPath: "/icons/sidebar-icons/user-search.svg",
    disabled: false,
  },
  {
    id: "community_suppliers",
    text: "community_suppliers",
    link: "/my-suppliers",
    iconPath: "/icons/sidebar-icons/user.svg",
    showTooltip: true,
    disabled: false,
  },
  {
    id: "community_members",
    text: "community_members",
    link: "/my-members",
    iconPath: "/icons/sidebar-icons/users.svg",
    disabled: false,
  },
  {
    id: "community_settings",
    text: "community_settings",
    link: "/community-settings",
    iconPath: "/icons/sidebar-icons/community-settings.svg",
    showTooltip: true,
    disabled: false,
  },
];
